import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios, { removeBracketedText } from '../Axiosinstance';
import Charisma from '.././images/Charisma.png'
import {
    TextField,
    Button,
    Grid,
    Typography,
    Container,
    Paper,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip,
    LinearProgress, Slide, CircularProgress, Alert
} from '@mui/material'
import TablePagination from '@mui/material/TablePagination';
import Header from '../components/Header';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import Newstudent from './Newstudent'
import Loader from '../Loader';
import Modal from 'react-bootstrap/Modal';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ApplicationForm from './ApplicationForm';
import Transcript from './Transcript';
import OfferLetter from '../components/OfferLetter.jsx';
import Invitation from '../pdf/Invitation.pdf'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
// import icon from '../All/images/tick-icon.png';
// import fs from 'fs';
import fontkit from '@pdf-lib/fontkit';  // Import fontkit for custom fonts
import TimesRoman from '../fonts/Times-Roman.ttf';
import Arialmt from '../fonts/arialmt.ttf'
import ARIALNormal from '../fonts/Arial-bold.ttf'
import TimesNewRomanBold from '../fonts/TimesNewRomanBold.ttf';
import courserecipt from '../pdf/courserecipt.pdf'
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


const columns = [
    { id: 'S.NO', label: 'S.NO', minWidth: 170 },
    { id: 'name', label: 'Name', minWidth: 170 },
    { id: 'NRIC/FIN No', label: 'NRIC/FIN No', minWidth: 170 },
    { id: 'email', label: 'Email', minWidth: 170 },
    { id: 'phone', label: 'Phone', minWidth: 170 },
    { id: 'gender', label: 'Gender', minWidth: 170 },
    // { id: 'Type', label: 'Course Type', minWidth: 170 },
    { id: 'Documents Date', label: 'Documents Date', minWidth: 170 },
    { id: 'actions', label: 'Actions', minWidth: 170 },
    { id: 'Application', label: 'Application', minWidth: 170 },
    { id: 'Transcript', label: 'Transcript', minWidth: 170 },
    { id: 'Offer', label: 'Offer', minWidth: 170 },
    { id: 'View', label: 'View', minWidth: 170 },
    // { id: 'Invitation', label: 'Invitation', minWidth: 170 },
    // { id: 'Reciept', label: 'Reciept', minWidth: 170 },
];


const Screen = () => {
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [studentsPerPage, setStudentsPerPage] = useState(100);
    const [searchQuery, setSearchQuery] = useState('');
    const [filterGender, setFilterGender] = useState('');
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [editedStudent, setEditedStudent] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const [uploadedImageUrl, setUploadedImageUrl] = useState('');
    const [isReadOnly, setIsReadOnly] = useState(true);
    const [dataForprop, setDataForprop] = useState(null);
    const [showEmploymentFields, setShowEmploymentFields] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const [openTranscriptDialog, setOpenTranscriptDialog] = useState(false);
    const [transcriptDate, setTranscriptDate] = useState('');
    const [currentStudent, setCurrentStudent] = useState(null);
    const [availableCourses, setAvailableCourses] = useState([]);

    const [filterCourse, setFilterCourse] = useState('All');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const hasIncompleteMarks = currentStudent?.markSheets?.some(sheet => sheet.mark === -1);
    const canView = currentStudent?.transcriptIssueDate && currentStudent?.transcriptNumber;


    const applicationFormRef = useRef(null);
    const TranscriptRef = useRef(null)
    const offerLetterRef = useRef(null);

    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        fetchStudents();
    }, []);


    const [selectedProfileFile, setSelectedProfileFile] = useState(null);
    const [selectedNricFile, setSelectedNricFile] = useState(null);
    const [selectedPassportFile, setSelectedPassportFile] = useState(null);
    const [selectedEducationFile, setSelectedEducationFile] = useState(null);

    useEffect(() => {
        if (editedStudent) {
            setSelectedProfileFile(null);
            setSelectedNricFile(null);
            setSelectedPassportFile(null);
            setSelectedEducationFile(null);
        }
    }, [editedStudent]);

    const fetchStudents = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                "registrationadvances/registration/status?status=Active"
            );
            setStudents(response.data.reverse());
            setLoading(false);
        } catch (error) {
            console.error("Error fetching students:", error);
            setLoading(false);
        }
    };


    useEffect(() => {
        if (students.length) {
            const uniqueCourses = Array.from(
                new Set(students.map((s) => s.course).filter(Boolean))
            );
            setAvailableCourses(uniqueCourses);
        }
    }, [students]);

    const handleApplicationForm = (student) => {
        if (applicationFormRef.current) {
            applicationFormRef.current.handleDownload(student); // Call handlePdfEdit function of the child component
        }
    };

    const handleOfferForm = (student) => {
        if (offerLetterRef.current) {
            offerLetterRef.current.handleDownload(student); // Call handlePdfEdit function of the child component
        }
    };

    const handleTranscript = (student) => {
        setCurrentStudent(student);
        setTranscriptDate(student.transcriptIssueDate || '');
        setOpenTranscriptDialog(true);
    };

    const handleViewTranscript = () => {
        if (hasIncompleteMarks) {
            toast.error('Please update all marks before viewing the transcript.');
            return;
        }

        setOpenTranscriptDialog(false);

        if (TranscriptRef.current) {
            TranscriptRef.current.handleDownload(currentStudent);
        }
    };



    const handleSaveTranscriptDate = async () => {
        if (!transcriptDate || !currentStudent) return;

        try {
            await axios.post(
                `/registrationadvances/generateTranscript`,
                null,
                { params: { id: currentStudent.id, date: transcriptDate } }
            );

            fetchStudents()
            toast.success('Transcript info saved.');

            if (hasIncompleteMarks) {
                toast.error('Marks are incomplete. Please complete all marks before viewing.');
                setOpenTranscriptDialog(false);
                return;
            }

            setOpenTranscriptDialog(false);

            // Optionally refresh student data here...

            if (TranscriptRef.current) {
                TranscriptRef.current.handleDownload({
                    ...currentStudent,
                    transcriptIssueDate: transcriptDate,
                    transcriptNumber: currentStudent.transcriptNumber || 'AUTO-GENERATED',
                });
            }
        } catch (error) {
            toast.error('Failed to save transcript info.');
        }
    };






    useEffect(() => {
        let filtered = students;

        // Gender Filter
        if (filterGender && filterGender.toLowerCase() !== "all") {
            filtered = filtered.filter(student =>
                student.gender?.toLowerCase() === filterGender.toLowerCase()
            );
        }

        // Course Filter
        if (filterCourse && filterCourse.toLowerCase() !== "all") {
            filtered = filtered.filter(student =>
                student.course?.toLowerCase() === filterCourse.toLowerCase()
            );
        }

        // Date Range Filter on scheduleDate
        if (fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);

            filtered = filtered.filter(student => {
                if (!student.scheduleDate) return false;

                return student.scheduleDate.some(schedule => {
                    const scheduleStart = new Date(schedule.startDate);
                    const scheduleEnd = new Date(schedule.endDate);

                    return (
                        (scheduleStart >= from && scheduleStart <= to) ||
                        (scheduleEnd >= from && scheduleEnd <= to) ||
                        (scheduleStart <= from && scheduleEnd >= to) // range fully overlaps
                    );
                });
            });
        }

        // Search Filter
        const searchFiltered = filtered.filter((student) =>
            student.name.toLowerCase().includes(searchQuery.toLowerCase())
        );

        setFilteredStudents(searchFiltered);
    }, [searchQuery, filterGender, filterCourse, fromDate, toDate, students]);


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };


    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletingStudentId, setDeletingStudentId] = useState(null);

    const DeleteConfirmationModal = ({ show, handleClose, handleConfirm }) => {
        return (
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this student?</Modal.Body>
                <Modal.Footer>
                    <Button style={{ backgroundColor: 'grey', color: 'white' }} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: 'red', color: 'white', marginLeft: '10px' }} onClick={() => handleConfirm(deletingStudentId)}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

const openDetailsModal = (student, isEdit) => {
    setEditedStudent({
        ...student,
        emergencyContacts: student.emergencyContacts || []
    });

    setIsReadOnly(!isEdit);
    setEditModalOpen(true);
};

    const handleDelete = (id) => {
        setDeletingStudentId(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleConfirmDelete = async (id) => {
        try {
            // Send the PUT request to change the student's status
            await axios.delete(`/registrationadvances/${id}`);

            // Update the students state by filtering out the deleted student
            const updatedStudents = students.filter((student) => student.id !== id);
            setStudents(updatedStudents);
            setFilteredStudents(updatedStudents);

            // Show success message
            toast.success('Student deleted successfully');
        } catch (error) {
            console.error('Error deleting student:', error);
            // Handle error scenarios (e.g., showing an error message)
            toast.error('Failed to delete student. Please try again.');
        } finally {
            handleCloseDeleteModal();
        }
    };





    const closeEditModal = () => {
        setEditModalOpen(false);
    };



    const uploadFile = async (file, folderPath) => {
        const timestamp = Date.now();
        const fileExtension = file.name.split(".").pop();
        const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

        const formData = new FormData();
        formData.append("file", file, fileNameWithTimestamp);
        formData.append("upload_preset", CLOUDINARY_UPLOAD);
        formData.append("public_id", `${folderPath}/${fileNameWithTimestamp}`);

        const response = await fetch(CLOUDINARY_URL, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        return data.secure_url || ""; // Return the uploaded file's URL
    };

    const handleSaveEdit = async (e) => {
        e.preventDefault();

        try {
            // Validate fields
const requiredFields = [
    'name',
    'email',
    'phone',
    'nric',
    'password',
    'address',
    'passport',
    'passportExpiryDate',
    'citizenship',
    'gender',
    'signDate',
    'commencementDate',
    'completeDate'
];            const emptyFields = requiredFields.filter(
                (field) => !editedStudent[field] || editedStudent[field].trim() === ''
            );

            if (emptyFields.length > 0) {
                toast.error(`The following fields are required: ${emptyFields.join(', ')}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }

            const confirmation = window.confirm(
                "Are you sure you want to update this student?"
            );
            if (!confirmation) {
                return;
            }

            // Existing URLs
            let profileUrl = editedStudent.profileUrl;
            let nricdoc = editedStudent.nricdoc;
            let passportdoc = editedStudent.passportdoc;
            let educationdoc = editedStudent.educationdoc;

            // Upload files if selected
            if (selectedProfileFile) {
                profileUrl = await uploadFile(
                    selectedProfileFile,
                    "LMS/Student/Profile"
                );
            }
            if (selectedNricFile) {
                nricdoc = await uploadFile(selectedNricFile, "LMS/Student/Nric");
            }
            if (selectedPassportFile) {
                passportdoc = await uploadFile(
                    selectedPassportFile,
                    "LMS/Student/Passport"
                );
            }
            if (selectedEducationFile) {
                educationdoc = await uploadFile(
                    selectedEducationFile,
                    "LMS/Student/Education"
                );
            }

            const updatedStudent = {
                ...editedStudent,
                profileUrl,
                nricdoc,
                passportdoc,
                educationdoc,
            };

            const response = await axios.put(
                `registrationadvances/${editedStudent.id}`,
                updatedStudent
            );

            if (response.status === 200) {
                const updatedStudents = students.map((student) =>
                    student.id === editedStudent.id ? updatedStudent : student
                );
                setStudents(updatedStudents);
                closeEditModal();
                toast.success("Student updated successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                console.error("Failed to update student");
                toast.error("Failed to update student", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.error("Error updating student:", error);
            toast.error("An error occurred while updating the student", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };



    const handleBulkDownload = () => {
        const filteredData = filteredStudents.map(student => ({
            Name: student.name,
            NRIC: student.nric,
            Email: student.email,
            Phone: student.phone,
            Gender: student.gender,
            DOB: student.dob,
            status: student.status,
            OfficePhone: student.officephone,
            Address: student.address,
            Course: student.course,
            Citizenship: student.citizenship,
            Passport: student.passport,
            PassportExpiryDate: student.passportExpiryDate,
            CurrentAddress: student.currentAddress,
            Religion: student.religion,
        }));

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Create worksheet from data
        const worksheet = XLSX.utils.json_to_sheet(filteredData, { origin: "A3" });

        // Add title manually in A1
        XLSX.utils.sheet_add_aoa(worksheet, [["AEG International College"]], { origin: "A1" });

        // Merge title across columns (adjust to number of columns, e.g., 13)
        worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 12 } }];

        // Apply style to title cell (bold and large)
        worksheet["A1"].s = {
            font: { name: "Arial", sz: 18, bold: true }, // Bold and larger font
            alignment: { horizontal: "center", vertical: "center" }
        };

        // Header styling (row 3)
        const headerRow = Object.keys(filteredData[0]);
        headerRow.forEach((col, index) => {
            const cellRef = XLSX.utils.encode_cell({ r: 2, c: index }); // r=2 is row 3 (0-based)
            if (!worksheet[cellRef]) return;
            worksheet[cellRef].s = {
                font: { bold: true },
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: "FFFF00" } // Yellow
                },
                alignment: { horizontal: "center" }
            };
        });

        // Adjust column widths
        worksheet["!cols"] = headerRow.map(() => ({ wch: 20 }));

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

        // Export to file
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
            cellStyles: true
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "students.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // const handleBulkDownload = async () => {
    //   const workbook = new ExcelJS.Workbook();
    //   const worksheet = workbook.addWorksheet("Students");

    //   // Column widths (add one for S.No)
    //   worksheet.columns = [
    //     { width: 5 },
    //     { width: 20 }, { width: 18 }, { width: 30 }, { width: 15 },
    //     { width: 10 }, { width: 15 }, { width: 15 }, { width: 30 },
    //     { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 },
    //     { width: 30 }, { width: 15 },
    //   ];

    //   // Title row
    //   worksheet.mergeCells("A1:O1"); 
    //   const titleCell = worksheet.getCell("A1");
    //   titleCell.value = "AEG International College";
    //   titleCell.font = { size: 18, bold: true };
    //   titleCell.alignment = { horizontal: "center", vertical: "middle" };

    //   worksheet.addRow([]); // Blank row

    //   // Header row
    //   const headers = [
    //     "S.No", "Name", "NRIC", "Email", "Phone", "Gender", "DOB", "OfficePhone",
    //     "Address", "Course", "Citizenship", "Passport", "PassportExpiryDate",
    //     "CurrentAddress", "Religion"
    //   ];
    //   const headerRow = worksheet.addRow(headers);
    //   headerRow.eachCell((cell) => {
    //     cell.font = { bold: true };
    //     cell.alignment = { horizontal: "center" };
    //     cell.border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };
    //   });

    //   // Data rows
    //   filteredStudents.forEach((student, index) => {
    //     const row = worksheet.addRow([
    //       index + 1, 
    //       student.name,
    //       student.nric,
    //       student.email,
    //       student.phone,
    //       student.gender,
    //       student.dob,
    //       student.officephone,
    //       student.address,
    //       student.course,
    //       student.citizenship,
    //       student.passport,
    //       student.passportExpiryDate,
    //       student.currentAddress,
    //       student.religion,
    //     ]);

    //     row.eachCell((cell) => {
    //       cell.fill = {
    //         type: "pattern",
    //         pattern: "solid",
    //         fgColor: { argb: "FFFF00" }, // Yellow
    //       };
    //       cell.border = {
    //         top: { style: "thin" },
    //         left: { style: "thin" },
    //         bottom: { style: "thin" },
    //         right: { style: "thin" },
    //       };
    //     });
    //   });

    //   // Download Excel
    //   const buffer = await workbook.xlsx.writeBuffer();
    //   const blob = new Blob([buffer], {
    //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //   });
    //   saveAs(blob, "students.xlsx");
    // };

    const handledownloadReciept = async (feeDetail, selectedStudent) => {
        function toCustomTitleCase(str) {
            const lowercaseWords = ['and'];
            return str
                .toLowerCase()
                .split(' ')
                .map((word, index) => {
                    if (index === 0 || !lowercaseWords.includes(word)) {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    } else {
                        return word;
                    }
                })
                .join(' ');
        }
        function formatCourseTitle(course) {
            if (!course) return { line1: '', line2: '' };
            const cleaned = toCustomTitleCase(removeBracketedText(course));
            const words = cleaned.split(' ');
            // Dynamic line break after ~35 characters
            const maxLength = 35;
            let splitIndex = 0;
            let currentLength = 0;
            for (let i = 0; i < words.length; i++) {
                currentLength += words[i].length + 1;
                if (currentLength > maxLength && i > 0) break;
                splitIndex = i + 1;
            }
            const line1 = words.slice(0, splitIndex).join(' ');
            const line2 = words.slice(splitIndex).join(' ');
            return { line1, line2 };
        }
        function getOrdinal(n) {
            const num = parseInt(n);
            if (isNaN(num) || num <= 0) return ''; // return empty for 0 or invalid
            const suffix = ['th', 'st', 'nd', 'rd'];
            const v = num % 100;
            return num + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]) + ' Installment';
        }
        const { line1, line2 } = formatCourseTitle(feeDetail?.course || '');
        const installment = getOrdinal(feeDetail?.paymentfor);
        const proofType = (feeDetail?.proofType || '').toUpperCase();

        let label = '';
        if (proofType === 'NRIC') {
            label = 'NRIC';
        } else if (proofType === 'FIN') {
            label = 'FIN';
        }

        const valueToShow = feeDetail?.finNric || '';

        const gender = feeDetail?.gender;
        let salutation = '';

        if (gender === 'Male') {
            salutation = 'MR ';
        } else if (gender === 'Female') {
            salutation = 'MS ';
        }

        const studentName = (feeDetail?.studentName || '').toUpperCase();
        const fullName = `${salutation}. ${studentName}`.trim();

        console.log("feeDetail", feeDetail);
        const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);

        pdfDoc.registerFontkit(fontkit);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const timesRomanBytes = await fetch(Arialmt).then(res => res.arrayBuffer());
        const timesNewRomanBoldBytes = await fetch(ARIALNormal).then(res => res.arrayBuffer());
        const courierfont = await pdfDoc.embedFont(timesRomanBytes);
        const courierfontbold = await pdfDoc.embedFont(timesNewRomanBoldBytes);

        const amountText = feeDetail?.amount ? `${(feeDetail.amount.toFixed(2))}` : ''; // Ensure the dollar symbol is always present
        const amountText1 = feeDetail?.amount ? `${(feeDetail.amount.toFixed(2))}` : '';

        const feestypeRaw = feeDetail?.feestype?.toLowerCase();

        const feestypeLabel =
            feestypeRaw === "registration fee"
                ? "Reg fees"
                : feestypeRaw === "course fee"
                    ? "Course fees"
                    : "";

        const amountText2 = feeDetail?.amount ? `$${feeDetail.amount}` : "";
        const fullText = `${feestypeLabel}:- ${amountText2}`.trim();

        const amountText3 = feeDetail?.amount ? `${(feeDetail.amount.toFixed(2))}` : '';
        const balanceToDisplay = feeDetail?.feestype === 'Course fee'
            ? feeDetail?.courseFeebalance?.toFixed(2)
            : feeDetail?.registrationFeebalance?.toFixed(2);
        // Convert numbers to strings
        firstPage.drawText(fullName, { x: 18, y: 557, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(`${label}:- ${valueToShow}`, { x: 18, y: 543, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        // firstPage.drawText(String(removeBracketedText(feeDetail?.course) || '').toUpperCase(), { x: 18, y: 513, size: 11, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(line1, { x: 18, y: 513, size: 10, font: courierfont, color: rgb(0, 0, 0), });
        if (line2) { firstPage.drawText(line2, { x: 18, y: 498, size: 10, font: courierfont, color: rgb(0, 0, 0), }); }
        firstPage.drawText(String(selectedStudent?.customId || ''), { x: 37, y: 529, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(feeDetail?.invoiceNumber || ''), { x: 477, y: 738, size: 16, font: courierfontbold, color: rgb(130 / 255, 0 / 255, 29 / 255) });
        firstPage.drawText(String(formatDate(feeDetail?.date || '')), { x: 19, y: 408, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(String(formatDate(feeDetail?.date || '')), { x: 328, y: 535, size: 10, font: courierfont, color: rgb(130 / 255, 0 / 255, 29 / 255) });
        firstPage.drawText(amountText, { x: 560, y: 361, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(amountText1, { x: 560, y: 410, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        // firstPage.drawText(selectedStudent.scheduleDate[0].startDate, { x: 120, y: 590, size: 12, font: courierfont, color: rgb(0, 0, 0) });
        //firstPage.drawText("TAY SIM LEONG", { x: 78, y: 474, size: 12, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(` $${balanceToDisplay}`, { x: 265, y: 383, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(installment, { x: 289, y: 409, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(fullText, { x: 224, y: 396, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText(amountText3, { x: 467, y: 410, size: 10, font: courierfont, color: rgb(0, 0, 0) });
        firstPage.drawText("*** This is computer generated document. No signature is required ***", {
            x: 159,
            y: 230,
            size: 10,
            font: courierfont,
            color: rgb(0, 0, 0)
        });
        // firstPage.drawText(` S$${balanceToDisplay}`, { x: 434, y: 535, size: 10, font: courierfontbold, color: rgb(1, 1, 1), });
        const Pleasepay = `S$${balanceToDisplay}`;

        let drawX;

        if (balanceToDisplay === 0 || balanceToDisplay === '0.00') {
            drawX = 434; // Fixed position for zero
        } else {
            const textwidth = courierfont.widthOfTextAtSize(Pleasepay, 10);
            drawX = 474 - textwidth; // Right-align for non-zero
        }

        firstPage.drawText(Pleasepay, {
            x: drawX,
            y: 535,
            size: 10,
            font: courierfontbold,
            color: rgb(1, 1, 1),
        });

        const balanceString = `S$${balanceToDisplay}`;

        const textWidth = courierfont.widthOfTextAtSize(balanceString, 16);

        const rightAlignedX = 593 - textWidth;
        firstPage.drawText(balanceString, {
            x: rightAlignedX,
            y: 321,
            size: 16,
            font: courierfont,
            color: rgb(147 / 255, 4 / 255, 29 / 255),
        });
        // firstPage.drawText(` S$${balanceToDisplay}`, { x: 512, y: 321, size: 16, font: courierfont, color: rgb(147 / 255, 4 / 255, 29 / 255), });
        firstPage.drawText(String(1), { x: 436, y: 410, size: 10, font: courierfont, color: rgb(0, 0, 0), });
        let yPosition = 520;
        const lineHeight = 10;
        // drawWrappedText(firstPage, String(feeDetail?.description || ''), 77, yPosition, courierfontbold, 10, 380);
        yPosition -= lineHeight;
        // drawWrappedText(firstPage, `${sumOfDollars} Dollars Only`, 177, 464, courierfontbold, 10, 300);
        const pdfBytesModified = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    };


    const [isFocused, setIsFocused] = useState(false);


    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;

        const newInstitutionDetails = editedStudent.institutionDetails.map((institution, i) => {
            if (i === index) {
                const updatedInstitution = { ...institution, [name]: value };

                const fromYear = parseInt(updatedInstitution.fromYear);
                const toYear = parseInt(updatedInstitution.toYear);

                // Validate only if both years have 4 digits
                if (
                    !isNaN(fromYear) &&
                    !isNaN(toYear) &&
                    updatedInstitution.fromYear.length === 4 &&
                    updatedInstitution.toYear.length === 4
                ) {
                    if (fromYear > toYear) {
                        toast.error("From Year cannot be greater than To Year");
                    }
                }

                return updatedInstitution;
            }
            return institution;
        });

        setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
    };

    const handleAddEducation = () => {
        setEditedStudent({
            ...editedStudent,
            institutionDetails: [
                ...editedStudent.institutionDetails,
                { institution: '', year: '', qualificationsAchieved: '' },
            ],
        });
    };

    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = editedStudent.institutionDetails.filter((_, i) => i !== index);
        setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
    };


    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;

        const newWorkExperiences = editedStudent.workExpirences.map((experience, i) => {
            if (i === index) {
                const updatedExperience = { ...experience, [name]: value };

                const fromYear = parseInt(updatedExperience.fromYear);
                const toYear = parseInt(updatedExperience.toYear);

                // Validate only if both years have 4 digits
                if (
                    !isNaN(fromYear) &&
                    !isNaN(toYear) &&
                    updatedExperience.fromYear.length === 4 &&
                    updatedExperience.toYear.length === 4
                ) {
                    if (fromYear > toYear) {
                        toast.error("From Year cannot be greater than To Year in Work Experience");
                    }
                }

                return updatedExperience;
            }
            return experience;
        });

        setEditedStudent({
            ...editedStudent,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setEditedStudent((prevState) => ({
            ...prevState,
            workExpirences: [
                ...prevState.workExpirences,
                { name: '', position: '', year: '' }
            ]
        }));
        setShowEmploymentFields(true); // Show employment fields after adding
    };

    const handleRemoveWorkExperience = (index) => {
        const newWorkExperiences = editedStudent.workExpirences.filter((_, i) => i !== index);
        setEditedStudent({
            ...editedStudent,
            workExpirences: newWorkExperiences
        });
        if (newWorkExperiences.length === 0) {
            setShowEmploymentFields(false); // Hide employment fields if no experience entries
        }
    };

    const numberToWords = (number) => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];


        const numToWords = (num) => {
            let words = '';
            if (num >= 1000) {
                words += numToWords(Math.floor(num / 1000)) + ' Thousand ';
                num %= 1000;
            }
            if (num >= 100) {
                words += ones[Math.floor(num / 100)] + ' Hundred ';
                num %= 100;
            }
            if (num >= 20) {
                words += tens[Math.floor(num / 10)] + ' ';
                num %= 10;
            }
            if (num > 0) {
                if (num >= 11 && num <= 19) {
                    words += teens[num - 10] + ' ';
                } else {
                    words += ones[num] + ' ';
                }
            }
            return words.trim();
        };

        if (number === 0) return 'Zero';
        return numToWords(number);
    };

    const handleViewStudent = async (student) => {

        setSelectedStudent(student);
        // try {
        //     // First API call
        //     const response = await axios.get(`/student/${student.id}`);
        const courseFees = student.courseFees && student.courseFees.length > 0 ? student.courseFees : [];
        setPaymentDetails(courseFees);
        console.log("courseFees", courseFees);
        setShowModal(true);

        // } catch (error) {
        //     console.error('Error fetching student details:', error);
        // }
    };



    const handleCloseModal = () => {
        setShowModal(false);

    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad
        const year = date.getFullYear(); // Get full year

        return `${day}/${month}/${year}`;
    };





    const moduleDetailsMap = editedStudent?.batch?.moduleDetails.reduce((map, module) => {
        map[module.id] = module.moduleName;
        return map;
    }, {}) || {};

    const totalModules = Object.keys(moduleDetailsMap).length;

    const getModuleName = (startModulus) => {
        const adjustedId = ((startModulus - 1 + totalModules) % totalModules) + 1;
        return moduleDetailsMap[adjustedId] || `Unknown Module (ID: ${adjustedId})`;
    };

    const formatDate1 = (dateStr) => {
        const date = new Date(dateStr);
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return date.toLocaleDateString('en-GB', options);
    };



    return (
        <div>
            <div className="container" style={{ maxWidth: '1400px' }}>
                {loading ? (
                    <Loader />
                ) : (
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>

                        <Grid container spacing={2} alignItems="center" marginTop={'5px'} padding={' 7px 5px '}>
                            {/* Search Input */}
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Search by Name"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    InputProps={{ style: { borderRadius: '8px' } }}
                                />
                            </Grid>
                            {/* Gender Filter Dropdown */}
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Filter by Gender</InputLabel>
                                    <Select
                                        value={filterGender}
                                        onChange={(e) => setFilterGender(e.target.value)}
                                        label="Filter by Gender"
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <MenuItem value="All">All</MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* Course Filter Dropdown */}
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Filter by Course</InputLabel>
                                    <Select
                                        value={filterCourse}
                                        onChange={(e) => setFilterCourse(e.target.value)}
                                        label="Filter by Course"
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <MenuItem value="All">All</MenuItem>
                                        {availableCourses.map((course) => (
                                            <MenuItem key={course} value={course}>
                                                {course}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>

                            {/* Date Range Pickers */}
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    label="From Date"
                                    type="date"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    label="To Date"
                                    type="date"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </Grid>

                            {/* Bulk Download Button */}
                            <Grid item xs={12} sm={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={handleBulkDownload}
                                    style={{
                                        textTransform: 'capitalize',
                                        borderRadius: '8px',
                                        padding: '15px 15px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Bulk Download
                                </Button>
                            </Grid>
                        </Grid>
                        <br />
                        <TableContainer
                            sx={{
                                overflowX: 'auto',
                                maxWidth: '100%',
                                '@media (min-width: 768px)': { // Apply styles for screens smaller than 768px (mobile)
                                    overflowX: 'unset', // Enable horizontal scroll
                                },
                            }}
                        >
                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>

                                <Table aria-label="sticky table">
                                    <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align="center"
                                                    style={{ fontWeight: 'bold' }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>


                                    <TableBody>
                                        {filteredStudents
                                            .slice((currentPage - 1) * studentsPerPage, currentPage * studentsPerPage)
                                            .map((student, index) => (
                                                <TableRow key={student.id}>
                                                    <TableCell>{(currentPage - 1) * studentsPerPage + index + 1}</TableCell>

                                                    <TableCell align="center">
                                                        <span

                                                            title={`${student.name} details`}

                                                            style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
                                                            onClick={() => openDetailsModal(student, false)} // Pass 'false' for read-only mode
                                                        >
                                                            {student.name}
                                                        </span>
                                                    </TableCell>
                                                    {/* <TableCell>
                                                        <img
                                                            src={student.profileUrl ? student.profileUrl :
                                                                student.gender === 'Male' ?
                                                                    'https://uxwing.com/wp-content/themes/uxwing/download/peoples-avatars/default-profile-picture-male-icon.png' :
                                                                    student.gender === 'Female' ?
                                                                        'https://cdn3.iconfinder.com/data/icons/business-vol-26/100/Artboard_2-512.png' :
                                                                        'https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small/user-profile-icon-free-vector.jpg'}
                                                            alt="Profile"
                                                            style={{ width: '150px', height: '100px' }}
                                                        />
                                                    </TableCell> */}
                                                    <TableCell>{student.nric}</TableCell>
                                                    {/* <TableCell>
                                                        {student.nric
                                                            ? "*".repeat(student.nric.length - 4) + student.nric.slice(-4)
                                                            : "N/A"}
                                                    </TableCell> */}

                                                    <TableCell align="center">{student.email}</TableCell>
                                                    <TableCell>{student.phone}</TableCell>
                                                    <TableCell>{student.gender}</TableCell>
                                                    {/* <TableCell>{student.type}</TableCell> */}
                                                    <TableCell>{student.offerDate}</TableCell>
                                                    <TableCell style={{ width: '10%' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <BsPencilFill
                                                                style={{ marginRight: 10 }}
                                                                onClick={() => openDetailsModal(student, true)} // Pass 'true' for edit mode
                                                            />                    <DeleteRoundedIcon
                                                                style={{ color: 'red', marginLeft: 10 }}
                                                                onClick={() => handleDelete(student.id)}
                                                            />

                                                        </div>
                                                    </TableCell>
                                                    <TableCell><ApplicationForm ref={applicationFormRef} />
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            style={{ align: "center" }}
                                                            onClick={() => handleApplicationForm(student)} // Calls the function from ApplicationForm
                                                        > Application
                                                        </Button>


                                                    </TableCell>

                                                    <TableCell><Transcript ref={TranscriptRef} />
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            style={{ align: "center" }}
                                                            onClick={() => handleTranscript(student)} // Calls the function from ApplicationForm
                                                        > Transcript
                                                        </Button>


                                                    </TableCell>
                                                    <TableCell>
                                                        <OfferLetter ref={offerLetterRef} />
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => handleOfferForm(student)}
                                                        >
                                                            offer
                                                        </Button>
                                                    </TableCell>
                                                    {/* <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            // style={{ marginBottom: '10px', width: '45%', maxWidth: '180px' }}
                                                            // startIcon={<FontAwesomeIcon icon={faGraduationCap} />}
                                                            onClick={() => handlePdfEditcertificate(student)}
                                                        >
                                                            Invitation
                                                        </Button>
                                                    </TableCell> */}
                                                    <TableCell>
                                                        <Button variant="contained" style={{ align: "center" }} onClick={() => handleViewStudent(student)}>
                                                            View
                                                        </Button>

                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={filteredStudents.length}
                            rowsPerPage={studentsPerPage}
                            page={currentPage - 1}
                            labelDisplayedRows={({ from, to }) => `${from}-${to} Page No ${currentPage}`}
                            onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                            onRowsPerPageChange={(event) => {
                                setCurrentPage(1);
                                setStudentsPerPage(event.target.value);
                            }}
                        />
                    </Paper>
                )}
            </div>

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                fullscreen
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title>Student Details</Modal.Title> */}
                    {/* <Button onClick={handleDownloadPDF} variant="contained" color="primary">Download PDF</Button> */}
                </Modal.Header>
                <Modal.Body>
                    <div id="modalContent">
                        {paymentDetails && paymentDetails.length > 0 ? (
                            <>
                                <Grid item xs={10} md={6}>
                                    <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                                        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Payment Details</Typography>
                                        <TableContainer>
                                            <Grid item xs={12} md={6}>
                                                <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                                                    <div >
                                                        <div>
                                                            <Typography variant="h6" component="div" gutterBottom>
                                                                Course Fee Details
                                                            </Typography>
                                                            <TableContainer component={Paper}>
                                                                <Table aria-label="Registration fee details table">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell style={{ fontWeight: 'bold' }}>Invoice Number</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Date</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Amount Paid</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Description</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Discount</TableCell>

                                                                            <TableCell style={{ fontWeight: 'bold' }} >Action</TableCell>


                                                                            {/* <TableCell>Fee Type</TableCell> */}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {paymentDetails.filter(feeDetail => feeDetail.feestype === "Course fee").length > 0 ? (
                                                                            paymentDetails
                                                                                .filter(feeDetail => feeDetail.feestype === "Course fee")
                                                                                .map((feeDetail, index) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell>{feeDetail.invoiceNumber}</TableCell>
                                                                                        <TableCell>{formatDate(feeDetail.date)}</TableCell>
                                                                                        <TableCell>${feeDetail.amount}</TableCell>
                                                                                        <TableCell>{feeDetail.description}</TableCell>
                                                                                        <TableCell>{feeDetail.discount ? `$${feeDetail.discount}` : "NA"}</TableCell>

                                                                                        <TableCell>
                                                                                            <Button
                                                                                                variant="contained"
                                                                                                color="primary"
                                                                                                onClick={() => handledownloadReciept(feeDetail, selectedStudent)}
                                                                                            >
                                                                                                View Receipt
                                                                                            </Button>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                        ) : (
                                                                            <TableRow>
                                                                                <TableCell colSpan={6} align="center">
                                                                                    No data available
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                            <Typography variant="h6" component="div" gutterBottom style={{ marginTop: '20px' }}>
                                                                Registration Fee Details
                                                            </Typography>
                                                            <TableContainer component={Paper}>
                                                                <Table aria-label="Course Fee table">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Invoice Number</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Date</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Amount Paid</TableCell>
                                                                            <TableCell style={{ fontWeight: 'bold' }} >Description</TableCell>

                                                                            <TableCell style={{ fontWeight: 'bold' }} >Action</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {paymentDetails.filter(feeDetail => feeDetail.feestype === "Registration fee").length > 0 ? (
                                                                            paymentDetails
                                                                                .filter(feeDetail => feeDetail.feestype === "Registration fee")
                                                                                .map((feeDetail, index) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell>{feeDetail.invoiceNumber}</TableCell>
                                                                                        <TableCell>{formatDate(feeDetail.date)}</TableCell>
                                                                                        <TableCell>${feeDetail.amount}</TableCell>
                                                                                        <TableCell>{feeDetail.description}</TableCell>


                                                                                        <TableCell>
                                                                                            <Button
                                                                                                variant="contained"
                                                                                                color="primary"
                                                                                                onClick={() => handledownloadReciept(feeDetail, selectedStudent)}
                                                                                            >
                                                                                                View Receipt
                                                                                            </Button>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                        ) : (
                                                                            <TableRow>
                                                                                <TableCell colSpan={5} align="center">
                                                                                    No data available
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </TableBody>

                                                                </Table>
                                                            </TableContainer>
                                                        </div>
                                                    </div>

                                                    {/* <div style={{ marginTop: '20px' }}>
                            <App ref={childRef} dataProp={dataForprop} />
                            <Button variant="contained" color="primary" onClick={handleContractletter}>Student Contract</Button>
                            <span style={{ marginRight: '10px' }}></span>
                            <AdmissionOffer ref={admissionOfferRef} dataProp={dataForprop} />
                            <Button variant="contained" color="primary" onClick={handleOfferletter}>Offer Letter</Button>
                            <span style={{ marginRight: '10px' }}></span>
                            <ApplicationForm ref={applicationFormRef} dataProp={dataForprop} studentInfo={studentInfo} />
                            <Button variant="contained" color="primary" onClick={handleApplicationForm}>Application Form</Button>
                          </div> */}
                                                </Paper>
                                            </Grid>

                                        </TableContainer>
                                    </Paper>
                                </Grid>

                            </>
                        ) : (
                            <Typography variant="h6" style={{ textAlign: 'center', margin: '20px' }}>
                                No payment details available for this student.
                            </Typography>
                        )}
                    </div>


                </Modal.Body>
            </Modal>


            <Dialog open={isEditModalOpen} onClose={closeEditModal}
                PaperProps={{
                    style: {
                        width: '700px', // or '90vw' for responsive width
                        maxWidth: 'none',
                    },
                }} >
                <DialogTitle>
                    {isReadOnly ? 'Student Details' : 'Edit Student (AEG International College)'}
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSaveEdit}>
                        <div >
                            <TextField
                                label="Full Name"
                                name="fullname"
                                required
                                value={editedStudent ? editedStudent.name : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        const inputValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                        const truncatedValue = inputValue.substring(0, 25);
                                        if (truncatedValue.trim() !== '' || truncatedValue.length === 0) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                name: truncatedValue,
                                            });
                                        }
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                                <InputLabel id="proofType">proof Type*</InputLabel>
                                <Select

                                    id="proofType"
                                    name="proofType"
                                    value={editedStudent?.proofType || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({ ...editedStudent, proofType: e.target.value });
                                        }
                                    }}
                                    label="proof Type*"
                                >
                                    <MenuItem value=""> Select Proof Type</MenuItem>
                                    <MenuItem value="NRIC"> NRIC</MenuItem>
                                    <MenuItem value="FIN"> FIN</MenuItem>

                                </Select>
                            </FormControl>

                            <TextField
                                label="NRIC/FIN No*"
                                name="nric"
                                value={editedStudent ? editedStudent.nric : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only alphanumeric characters and limit to 12 characters
                                        const inputValue = e.target.value.replace(/[^A-Za-z0-9]/g, '').substring(0, 9);
                                        setEditedStudent({
                                            ...editedStudent,
                                            nric: inputValue,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Course Fee*"
                                name="courseFee"
                                value={editedStudent ? editedStudent.courseFee : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            courseFee: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />


                            <TextField
                                label="Email*"
                                name="email"
                                value={editedStudent ? editedStudent.email : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            email: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />





                            <TextField
                                label="Passport*"
                                name="passport"
                                value={editedStudent ? editedStudent.passport : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            passport: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                type="date"
                                label="Passport Expiry Date*"
                                name="passportexpiredate"
                                value={editedStudent ? editedStudent.passportExpiryDate : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            passportExpiryDate: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Citizenship*"
                                name="citizenship"
                                value={editedStudent ? editedStudent.citizenship : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            citizenship: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                type="date"
                                label="Documents Date*"
                                name="offerDate"
                                value={editedStudent ? editedStudent.offerDate : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            offerDate: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

<TextField
    type="date"
    label="Sign Date*"
    name="signDate"
    value={editedStudent ? editedStudent.signDate : ''}
    onChange={(e) => {
        if (!isReadOnly) {
            setEditedStudent({ ...editedStudent, signDate: e.target.value });
        }
    }}
    fullWidth
    margin="normal"
    InputLabelProps={{ shrink: true }}
    InputProps={{ readOnly: isReadOnly }}
/>

<TextField
    type="date"
    label="Commencement Date*"
    name="commencementDate"
    value={editedStudent ? editedStudent.commencementDate : ''}
    onChange={(e) => {
        if (!isReadOnly) {
            setEditedStudent({ ...editedStudent, commencementDate: e.target.value });
        }
    }}
    fullWidth
    margin="normal"
    InputLabelProps={{ shrink: true }}
    InputProps={{ readOnly: isReadOnly }}
/>

<TextField
    type="date"
    label="Complete Date*"
    name="completeDate"
    value={editedStudent ? editedStudent.completeDate : ''}
    onChange={(e) => {
        if (!isReadOnly) {
            setEditedStudent({ ...editedStudent, completeDate: e.target.value });
        }
    }}
    fullWidth
    margin="normal"
    InputLabelProps={{ shrink: true }}
    InputProps={{ readOnly: isReadOnly }}
/>

                            {/* <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                                <InputLabel id="course-label">Course Type*</InputLabel>
                                <Select
                                    labelId="course-label"
                                   id="type"
                                     name="type"
                                    value={editedStudent?.type || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({ ...editedStudent, type: e.target.value });
                                        }
                                    }}
                                    label="Course Type*"
                                >
                                    <MenuItem value=""> Select Course Type</MenuItem>
                                    <MenuItem value="diploma"> Diploma</MenuItem>
                                    <MenuItem value="advance_diploma"> Advanced Diploma</MenuItem>
                                    
                                </Select>
                            </FormControl> */}


                            <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                                <InputLabel id="Status">Status</InputLabel>
                                <Select

                                    id="status"
                                    name="Status"
                                    value={editedStudent?.status || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({ ...editedStudent, status: e.target.value });
                                        }
                                    }}
                                    label="Status"
                                >
                                    <MenuItem value=""> Select Status</MenuItem>
                                    <MenuItem value="Active"> Active</MenuItem>
                                    <MenuItem value="withdrawn"> withdrawn</MenuItem>
                                    {/* <MenuItem value="Alumni"> Graduation</MenuItem> */}

                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                                <InputLabel id="durationType">Duration Type*</InputLabel>
                                <Select

                                    id="durationType"
                                    name="durationType"
                                    value={editedStudent?.durationType || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({ ...editedStudent, durationType: e.target.value });
                                        }
                                    }}
                                    label="Duration Type*"
                                >
                                    <MenuItem value=""> Select Course Type</MenuItem>
                                    <MenuItem value="part_time"> Part Time</MenuItem>
                                    <MenuItem value="full_time"> Full TIme</MenuItem>

                                </Select>
                            </FormControl>


<FormControl fullWidth margin="normal" disabled={isReadOnly}>
    <InputLabel id="maritalStatus">Marital Status*</InputLabel>
    <Select
        id="maritalStatus"
        name="maritalStatus"
        value={editedStudent?.maritalStatus || ''}
        onChange={(e) => {
            if (!isReadOnly) {
                setEditedStudent({ ...editedStudent, maritalStatus: e.target.value });
            }
        }}
        label="Marital Status*"
    >
        <MenuItem value=""> Select Marital Status</MenuItem>
        <MenuItem value="Single"> Single</MenuItem>
        <MenuItem value="Married"> Married</MenuItem>
        <MenuItem value="Divorced"> Divorced</MenuItem>
        <MenuItem value="Widowed"> Widowed</MenuItem>
    </Select>
</FormControl>


                            <TextField
                                label="Course*"
                                name="course"
                                value={editedStudent ? editedStudent.course : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            course: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }} // Set TextField as read-only based on isReadOnly
                            />


                            <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                                <InputLabel id="gender-label">Gender*</InputLabel>
                                <Select
                                    labelId="gender-label"
                                    id="gender"
                                    name="gender"
                                    value={editedStudent?.gender || ''}
                                    onChange={(e) => {
                                        if (!isReadOnly) {
                                            setEditedStudent({ ...editedStudent, gender: e.target.value });
                                        }
                                    }}
                                    label="Gender*"
                                >
                                    <MenuItem value="">Select Gender</MenuItem>
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Other">Other</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                fullWidth
                                label="Date of Birth*"
                                type="date"
                                name="dob"
                                value={editedStudent?.dob || '2000-01-01'}
                                onChange={(e) => {
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            dob: e.target.value,
                                        });
                                    }
                                }}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    min: '1920-01-01',
                                    max: '2012-12-31',
                                    readOnly: isReadOnly,
                                }}
                                margin="normal"
                                disabled={isReadOnly}
                            />


                            <TextField
                                label="Home Phone*"
                                name="phone"
                                value={editedStudent ? editedStudent.phone : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only numeric characters and limit to 10 characters
                                        const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
                                        setEditedStudent({
                                            ...editedStudent,
                                            phone: inputValue,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />


                            <TextField
                                label="Student ID*"
                                name="customId"
                                value={editedStudent ? editedStudent.customId : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only numeric characters and limit to 10 characters
                                        const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
                                        setEditedStudent({
                                            ...editedStudent,
                                            customId: inputValue,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />



                            <TextField
                                label="Office Phone*"
                                name="officephone"
                                value={editedStudent ? editedStudent.officephone : ''}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only numeric characters and limit to 10 characters

                                        setEditedStudent({
                                            ...editedStudent,
                                            officephone: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />







                            <TextField
                                label="Password*"
                                name="password"
                                value={editedStudent ? editedStudent.password : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            password: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Singapore Address"
                                name="currentAddress"
                                value={editedStudent ? editedStudent.currentAddress : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            currentAddress: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />



                            <TextField
                                label="Home Address*"
                                name="address"
                                value={editedStudent ? editedStudent.address : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            address: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            {/* <TextField
                                label="Race*"
                                name="race"
                                value={editedStudent ? editedStudent.race : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            race: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            /> */}

                            <TextField
                                label="Religion*"
                                name="religion"
                                value={editedStudent ? editedStudent.religion : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            religion: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />






                            <TextField
                                label="Relationship"
                                name="relationship"
                                value={editedStudent ? editedStudent.relationship : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            relationship: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

{/* 
                            <TextField
                                label="Emergency Contact Name"
                                name="fatherName"
                                value={editedStudent ? editedStudent.fatherName : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            fatherName: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Emergency Contact Number"
                                name="fatherPhoneNo"
                                value={editedStudent ? editedStudent.fatherPhoneNo : ''}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            fatherPhoneNo: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            /> */}

<Grid item xs={12}>
    <Typography variant="h6" gutterBottom style={{ marginTop: '16px' }}>Emergency Contacts</Typography>
</Grid>

{(editedStudent?.emergencyContacts || []).map((contact, index) => (
    <Box key={index} mb={2} p={2} border={1} borderRadius={2} borderColor="grey.300">
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal" disabled={isReadOnly}>
                    <InputLabel>Relationship</InputLabel>
                    <Select
                        value={contact.relationship || ''}
                        label="Relationship"
                        onChange={(e) => {
                            if (isReadOnly) return;
                            const updated = [...editedStudent.emergencyContacts];
                            updated[index] = { ...updated[index], relationship: e.target.value };
                            setEditedStudent({ ...editedStudent, emergencyContacts: updated });
                        }}
                    >
                        <MenuItem value="">-- Select --</MenuItem>
                        <MenuItem value="Father">Father</MenuItem>
                        <MenuItem value="Mother">Mother</MenuItem>
                        <MenuItem value="Brother">Brother</MenuItem>
                        <MenuItem value="Sister">Sister</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            {contact.relationship === 'Others' && (
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Relationship with Applicant"
                        value={contact.othersRelationship || ''}
                        margin="normal"
                        InputProps={{ readOnly: isReadOnly }}
                        onChange={(e) => {
                            if (isReadOnly) return;
                            const updated = [...editedStudent.emergencyContacts];
                            updated[index] = { ...updated[index], othersRelationship: e.target.value };
                            setEditedStudent({ ...editedStudent, emergencyContacts: updated });
                        }}
                    />
                </Grid>
            )}

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Name"
                    value={contact.name || ''}
                    margin="normal"
                    InputProps={{ readOnly: isReadOnly }}
                    onChange={(e) => {
                        if (isReadOnly) return;
                        const updated = [...editedStudent.emergencyContacts];
                        updated[index] = { ...updated[index], name: e.target.value };
                        setEditedStudent({ ...editedStudent, emergencyContacts: updated });
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="Contact No"
                    value={contact.number || ''}
                    margin="normal"
                    InputProps={{ readOnly: isReadOnly }}
                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); }}
                    onChange={(e) => {
                        if (isReadOnly) return;
                        const updated = [...editedStudent.emergencyContacts];
                        updated[index] = { ...updated[index], number: e.target.value };
                        setEditedStudent({ ...editedStudent, emergencyContacts: updated });
                    }}
                />
            </Grid>

            {!isReadOnly && (
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            const updated = editedStudent.emergencyContacts.filter((_, i) => i !== index);
                            setEditedStudent({ ...editedStudent, emergencyContacts: updated });
                        }}
                    >
                        Remove
                    </Button>
                </Grid>
            )}
        </Grid>
    </Box>
))}

{!isReadOnly && (
    <Button
        type="button"
        variant="contained"
        onClick={() => {
            setEditedStudent({
                ...editedStudent,
                emergencyContacts: [
                    ...(editedStudent.emergencyContacts || []),
                    { name: '', number: '', relationship: '', othersRelationship: '' },
                ],
            });
        }}
        style={{ marginBottom: '10px' }}
    >
        + Add Emergency Contact
    </Button>
)}

                            {/* <TextField
                                label="Brother Name"
                                name="brotherName"
                                value={editedStudent ? editedStudent.brotherName : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            brotherName: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Brother Phone No"
                                name="brotherPhoneNo"
                                value={editedStudent ? editedStudent.brotherPhoneNo : ''}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            brotherPhoneNo: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            /> */}


                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload photo</Typography>
                                    <TextField
                                        type="file"
                                        id="profileUpload"
                                        fullWidth
                                        accept="image/png, image/jpeg, image/jpg"
                                        // inputProps={{ accept: 'image/*', readOnly: isReadOnly }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;

                                            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

                                            if (file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                toast.error("File size must be less than 8MB.");
                                            } else if (!allowedTypes.includes(file.type)) {
                                                e.target.value = "";
                                                toast.error("Invalid file type. Only PNG, JPG, or JPEG are allowed.");
                                            } else {
                                                setSelectedProfileFile(file);
                                            }
                                        }}
                                        variant="outlined"
                                        style={{ marginTop: '8px' }}
                                        disabled={isReadOnly}
                                    />
                                    {editedStudent?.profileUrl && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            href={editedStudent.profileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                marginTop: '8px',
                                                color: 'white',
                                                '&:hover': {
                                                    color: 'white'
                                                }
                                            }}
                                        >
                                            View
                                        </Button>
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload NRIC</Typography>
                                    <TextField
                                        type="file"
                                        id="nricUpload"
                                        fullWidth
                                        accept="application/pdf"                                        // inputProps={{ accept: 'image/*', readOnly: isReadOnly }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;

                                            const allowedTypes = ['application/pdf'];

                                            if (file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                toast.error("File size must be less than 8MB.");
                                            } else if (!allowedTypes.includes(file.type)) {
                                                e.target.value = "";
                                                toast.error("Invalid file type. Only PDF files are allowed.");
                                            } else {
                                                setSelectedNricFile(file);
                                            }
                                        }} variant="outlined"
                                        style={{ marginTop: '8px' }}
                                        disabled={isReadOnly}
                                    />
                                    {editedStudent?.nricdoc && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            href={editedStudent.nricdoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                marginTop: '8px',
                                                color: 'white',
                                                '&:hover': {
                                                    color: 'white'
                                                }
                                            }}
                                        >
                                            View NRIC Document
                                        </Button>
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload Passport</Typography>
                                    <TextField
                                        type="file"
                                        id="passportUpload"
                                        fullWidth
                                        accept="application/pdf"
                                        // inputProps={{ accept: 'image/*', readOnly: isReadOnly }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;

                                            const allowedTypes = ['application/pdf'];

                                            if (file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                toast.error("File size must be less than 8MB.");
                                            } else if (!allowedTypes.includes(file.type)) {
                                                e.target.value = "";
                                                toast.error("Invalid file type. Only PDF files are allowed.");
                                            } else {
                                                setSelectedPassportFile(file);
                                            }
                                        }} variant="outlined"
                                        style={{ marginTop: '8px' }}
                                        disabled={isReadOnly}
                                    />
                                    {editedStudent?.passportdoc && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            href={editedStudent.passportdoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                marginTop: '8px',
                                                color: 'white',
                                                '&:hover': {
                                                    color: 'white'
                                                }
                                            }}
                                        >
                                            View Passport Document
                                        </Button>
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload Education Document</Typography>
                                    <TextField
                                        type="file"
                                        id="educationUpload"
                                        fullWidth
                                        accept="application/pdf"
                                        // inputProps={{ accept: 'application/pdf, image/*', readOnly: isReadOnly }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;

                                            const allowedTypes = ['application/pdf'];

                                            if (file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                toast.error("File size must be less than 8MB.");
                                            } else if (!allowedTypes.includes(file.type)) {
                                                e.target.value = "";
                                                toast.error("Invalid file type. Only PDF files are allowed.");
                                            } else {
                                                setSelectedEducationFile(file);
                                            }
                                        }} variant="outlined"
                                        style={{ marginTop: '8px' }}
                                        disabled={isReadOnly}
                                    />
                                    {editedStudent?.educationdoc && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            href={editedStudent.educationdoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                marginTop: '8px',
                                                color: 'white',
                                                '&:hover': {
                                                    color: 'white'
                                                }
                                            }}
                                        >
                                            View Education Document
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                            <br />

                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Start Date</TableCell>
                                        <TableCell>End Date</TableCell>
                                        <TableCell>Module</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(Array.isArray(editedStudent?.scheduleDate) ? editedStudent.scheduleDate : []).map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{formatDate1(item.startDate)}</TableCell>
                                            <TableCell>{formatDate1(item.endDate)}</TableCell>
                                            <TableCell>{getModuleName(item.startModulus)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>




                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>Educational Details</Typography>
                            </Grid>

                            {editedStudent.workExpirences && (
                                editedStudent.institutionDetails.map((institution, index) => (
                                    <Box key={index} mb={4} p={2} border={1} borderRadius={2} borderColor="grey.300">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={`Institution Name - ${index + 1}`}
                                                    id={`institutionName-${index}`}
                                                    name="institution"
                                                    value={institution.institution}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Degree"
                                                    id={`degree-${index}`}
                                                    name="qualificationsAchieved"
                                                    value={institution.qualificationsAchieved}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    label="Certificate Number"
                                                    id={`educationCertificateNo-${index}`}
                                                    name="educationCertificateNo"
                                                    value={institution.educationCertificateNo}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    label="Country"
                                                    id={`country-${index}`}
                                                    name="country"
                                                    value={institution.country}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            <Grid item xs={6} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    label="From Year"
                                                    id={`fromYear-${index}`}
                                                    name="fromYear"
                                                    value={institution.fromYear}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            <Grid item xs={6} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    label="To Year"
                                                    id={`toYear-${index}`}
                                                    name="toYear"
                                                    value={institution.toYear}
                                                    onChange={(e) => handleInstitutionChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                />
                                            </Grid>

                                            {!isReadOnly && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={() => handleRemoveEducation(index)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>


                                ))
                            )}
                            {!isReadOnly && (
                                <Button
                                    type="button"
                                    onClick={handleAddEducation}
                                    disabled={isReadOnly}
                                    style={{
                                        margin: '10px 0',
                                        padding: '10px 29px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    + Add Education
                                </Button>
                            )}


                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>Work Details</Typography>
                            </Grid>

                            {editedStudent.workExpirences && (
                                editedStudent.workExpirences.map((experience, index) => (
                                    <Box key={index} mb={4} p={2} border={1} borderColor="grey.300" borderRadius={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={`Company Name - ${index + 1}`}
                                                    id={`companyname-${index}`}
                                                    name="name"
                                                    value={experience.name}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                    margin="normal"
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Nature of Duties"
                                                    id={`position-${index}`}
                                                    name="position"
                                                    value={experience.position}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                    margin="normal"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    label="Country"
                                                    id={`country-${index}`}
                                                    name="country"
                                                    value={experience.country}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                    margin="normal"
                                                />
                                            </Grid>

                                            <Grid item xs={6} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    label="From Year"
                                                    id={`fromYear-${index}`}
                                                    name="fromYear"
                                                    value={experience.fromYear}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                    margin="normal"
                                                />
                                            </Grid>

                                            <Grid item xs={6} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    label="To Year"
                                                    id={`toYear-${index}`}
                                                    name="toYear"
                                                    value={experience.toYear}
                                                    onChange={(e) => handleWorkExperienceChange(index, e)}
                                                    InputProps={{ readOnly: isReadOnly }}
                                                    margin="normal"
                                                />
                                            </Grid>

                                            {!isReadOnly && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={() => handleRemoveWorkExperience(index)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>


                                ))
                            )}
                            {!isReadOnly && (
                                <Button
                                    type="button"
                                    onClick={handleAddWorkExperience}
                                    style={{
                                        margin: '10px 0',
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    + Add Employment

                                </Button>
                            )}

                            {/* <div className="col-md-6">
                                <label htmlFor="file" className="form-label">Profile image*</label>

                                {isReadOnly ? null : (
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={handleFileChange}
                                        className="form-control"
                                        disabled={isReadOnly}
                                    />

                                )}

                                {selectedFile && <div>Selected File: {selectedFile.name}</div>}
                            </div> */}


                            {/* Display the uploaded image */}
                            {/* <div>
                                <p>Image:</p>
                                {selectedFile ? (
                                    <img style={{ width: '150px', height: '100px' }} src={URL.createObjectURL(selectedFile)} alt="Uploaded" />
                                ) : (
                                    <img style={{ width: '150px', height: '100px' }} src={uploadedImageUrl || editedStudent.profileUrl} alt="Existing" />
                                )}
                            </div> */}


                        </div>    </form>
                </DialogContent>
                <DialogActions>
                    {!isReadOnly && ( // Conditionally render the Update button based on read-only mode
                        <Button onClick={handleSaveEdit} variant="contained" color="primary" style={{ backgroundColor: 'green', color: 'white' }}>
                            Update
                        </Button>
                    )}
                    <Button onClick={closeEditModal} variant="contained" color="secondary" style={{ backgroundColor: 'red', color: 'white' }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
            <DeleteConfirmationModal
                show={showDeleteModal}
                handleClose={handleCloseDeleteModal}
                handleConfirm={handleConfirmDelete}
            />

            <Dialog open={openTranscriptDialog} onClose={() => setOpenTranscriptDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {currentStudent?.transcriptIssueDate ? 'Update Transcript Details' : 'Enter Transcript Details'}
                </DialogTitle>

                <DialogContent dividers>
                    <Typography variant="body2" gutterBottom>
                        Please confirm or update the issue date of the transcript.
                    </Typography>

                    <TextField
                        label="Transcript Issue Date"
                        type="date"
                        value={transcriptDate}
                        onChange={(e) => setTranscriptDate(e.target.value)}
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />

                    {hasIncompleteMarks && (
                        <Alert severity="warning" sx={{ mt: 2 }}>
                            Some modules are missing marks. Please complete all marks before downloading the transcript.
                        </Alert>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenTranscriptDialog(false)} color="inherit">Cancel</Button>

                    {canView && (
                        <Button
                            variant="outlined"
                            onClick={handleViewTranscript}
                            disabled={hasIncompleteMarks}
                        >
                            View Transcript
                        </Button>
                    )}

                    <Button
                        variant="contained"
                        onClick={handleSaveTranscriptDate}
                        disabled={!transcriptDate}
                    >
                        {currentStudent?.transcriptIssueDate ? 'Update' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>




        </div >
    );
};


const New = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };



    const handleTabChange = (newValue) => {
        setTabValue(newValue);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div>
            <Header />
            <br />
            <div className="d-flex justify-content-center mt-4">
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="Students-tabs"
                    variant="fullWidth"
                    sx={{
                        borderRadius: 10,
                        display: 'flex',
                        justifyContent: 'center',
                        "& button": {
                            borderRadius: 10,
                            color: "#555",

                            margin: 'auto',
                            display: 'block'
                        },
                        "& button:hover": {
                            backgroundColor: "#eee",
                        },
                        "& button:active": {
                            backgroundColor: "#ddd",
                        },
                        "& button.Mui-selected": {
                            backgroundColor: "#007bff",
                            color: "#fff",
                        },
                        "& .MuiTabs-indicator": {
                            display: 'none', // Remove the underline
                        },
                        ...(isMobile && {
                            flexDirection: 'column', // Stack tabs vertically
                            "& button": {
                                width: '100%', // Set tabs to full width on mobile
                            },
                        }),
                    }}
                >
                    <Tab label="All Students" sx={{ minWidth: isMobile ? '50%' : '620px' }} />
                    <Tab label="New Student" sx={{ minWidth: isMobile ? '50%' : '620px' }} />
                </Tabs>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                {tabValue === 0 && <Screen />}
                {tabValue === 1 && <Newstudent onFormSubmit={() => handleTabChange(0)} />}
            </div>
            {/* <div
        style={{
          position: 'absolute',
          bottom: '30px', // Adjust to desired distance from the bottom
          right: '30px', // Adjust to desired distance from the right
          opacity: 0.5, // Transparency for the image
          zIndex: 1, // Ensure it is below other UI elements
          pointerEvents: 'none',
        }}
      >
        <img
         src={Charisma}
          alt="Charisma"
          style={{
            maxWidth: '120px', // Adjust the size as needed
            maxHeight: '120px',
          }}
        />
      </div> */}
        </div>
    );



};

export default New;